import axios from 'axios';

// Configuration pour MS_Client (ou MS_Admin selon votre architecture)
const DEFAULT_API_URL = 'http://localhost:5000';

const getApiBaseUrl = () => {
    let baseUrl = process.env.REACT_APP_BASEURL_CLIENT_BACKEND || DEFAULT_API_URL;
    baseUrl = baseUrl.replace(/\/$/, '');

    try {
        new URL(baseUrl);
        return baseUrl;
    } catch (e) {
        console.error('URL API invalide:', baseUrl);
        return DEFAULT_API_URL;
    }
};

const API_BASE_URL = `${getApiBaseUrl()}/api/cartes/paiements`;

export const paiementsService = {
    // Récupérer les paiements avec filtres
    getPaiements: async (params = {}) => {
        try {
            const response = await axios.get(API_BASE_URL, { params });
            return response.data;
        } catch (error) {
            console.error('Erreur lors de la récupération des paiements:', error);
            throw error;
        }
    },

    // Récupérer les statistiques
    getStatistics: async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/statistics`);
            return response.data;
        } catch (error) {
            console.error('Erreur lors de la récupération des statistiques:', error);
            throw error;
        }
    },

    // Récupérer un paiement par ID
    getPaiementById: async (id) => {
        try {
            const response = await axios.get(`${API_BASE_URL}/${id}`);
            return response.data;
        } catch (error) {
            console.error(`Erreur lors de la récupération du paiement ${id}:`, error);
            throw error;
        }
    },

    // Enregistrer un nouveau paiement
    enregistrerPaiement: async (factureId, paiementData) => {
        try {
            const response = await axios.post(`${API_BASE_URL}/enregistrer`, {
                factureId,
                ...paiementData
            });
            return response.data;
        } catch (error) {
            console.error('Erreur lors de l\'enregistrement du paiement:', error);
            throw error;
        }
    },

    // Annuler un paiement
    annulerPaiement: async (id, motif) => {
        try {
            const response = await axios.post(`${API_BASE_URL}/${id}/annuler`, { motif });
            return response.data;
        } catch (error) {
            console.error(`Erreur lors de l\'annulation du paiement ${id}:`, error);
            throw error;
        }
    },

    // Télécharger une facture
    downloadFacture: async (id) => {
        try {
            const response = await axios.get(`${API_BASE_URL}/${id}/facture`, {
                responseType: 'blob'
            });
            return response;
        } catch (error) {
            console.error(`Erreur lors du téléchargement de la facture ${id}:`, error);
            throw error;
        }
    },

    // Télécharger un reçu de paiement
    downloadRecu: async (id) => {
        try {
            const response = await axios.get(`${API_BASE_URL}/${id}/recu`, {
                responseType: 'blob'
            });
            return response;
        } catch (error) {
            console.error(`Erreur lors du téléchargement du reçu ${id}:`, error);
            throw error;
        }
    },

    // Exporter vers Excel
    exportToExcel: async (filters = {}) => {
        try {
            const response = await axios.post(`${API_BASE_URL}/export/excel`, filters, {
                responseType: 'blob'
            });
            return response;
        } catch (error) {
            console.error('Erreur lors de l\'export Excel:', error);
            throw error;
        }
    },

    // Récupérer l'historique des paiements d'un souscripteur
    getHistoriqueSouscripteur: async (souscripteurId) => {
        try {
            const response = await axios.get(`${API_BASE_URL}/souscripteur/${souscripteurId}/historique`);
            return response.data;
        } catch (error) {
            console.error(`Erreur lors de la récupération de l\'historique du souscripteur ${souscripteurId}:`, error);
            throw error;
        }
    },

    // Envoyer un rappel de paiement
    envoyerRappel: async (factureId) => {
        try {
            const response = await axios.post(`${API_BASE_URL}/rappel/${factureId}`);
            return response.data;
        } catch (error) {
            console.error(`Erreur lors de l\'envoi du rappel pour la facture ${factureId}:`, error);
            throw error;
        }
    },

    // Générer un rapport de paiements
    genererRapport: async (dateDebut, dateFin, type = 'MENSUEL') => {
        try {
            const response = await axios.post(`${API_BASE_URL}/rapport`, {
                dateDebut,
                dateFin,
                type
            });
            return response.data;
        } catch (error) {
            console.error('Erreur lors de la génération du rapport:', error);
            throw error;
        }
    },

    // Récupérer les paiements en retard
    getPaiementsEnRetard: async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/retard`);
            return response.data;
        } catch (error) {
            console.error('Erreur lors de la récupération des paiements en retard:', error);
            throw error;
        }
    },

    // Mettre à jour le statut d'un paiement
    updateStatutPaiement: async (id, status) => {
        try {
            const response = await axios.patch(`${API_BASE_URL}/${id}/status`, { status });
            return response.data;
        } catch (error) {
            console.error(`Erreur lors de la mise à jour du statut du paiement ${id}:`, error);
            throw error;
        }
    },

    // Traitement en masse des paiements
    traiterPaiementsEnMasse: async (paiementIds, action) => {
        try {
            const response = await axios.post(`${API_BASE_URL}/masse`, {
                ids: paiementIds,
                action
            });
            return response.data;
        } catch (error) {
            console.error('Erreur lors du traitement en masse des paiements:', error);
            throw error;
        }
    }
};